import { Box } from '@chakra-ui/react'
import { useState } from 'react'

import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { useOffersTravelContext } from '@/context/OffersTravelProvider'

import { Step2 } from '.'
import { Note } from '../../../../components/Note'
import { Steps } from '../../../../components/Steps'
import { WizzardHeader } from '../../../../components/WizzardHeader'
import { PageWrapper } from '../../../../layouts/components/PageWrapper'
import { SendCalculationProvider } from '../../SendCalculationModal'

function Step2Wrapper() {
  const [noteText, setNoteText] = useState<string | undefined>(undefined)

  const handleCreateNote = () => {
    setNoteText('Nová poznámka')
  }

  const { insuranceParams } = useInsuranceParams()
  const { offers } = useOffersTravelContext()
  const offerIdsToPrint = offers.filter(x => x.print).map(x => x.offerId)


  return (<SendCalculationProvider paramsId={insuranceParams!.generalParams.paramsId!} offerIds={offerIdsToPrint} editable>
    <PageWrapper
      steps={<Steps />}
      header={<WizzardHeader onCreateNote={handleCreateNote} />}
      contentProps={{
        sx: {
          pt: { base: 0, md: 0 },
        },
      }}
    >
      {noteText && noteText !== '' && (
        <Note
          date="11.10.2021 14:35"
          text={noteText}
          onChange={(text) => setNoteText(text)}
        />
      )}

      <Box sx={{ pt: { base: 0, md: !noteText ? 8 : 0 } }}>
        <Step2 />
      </Box>
    </PageWrapper>
  </SendCalculationProvider>
  )
}

export default Step2Wrapper